import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {KeyValueObj, PortalLanguageObj} from 'mx-core';

const LANGUAGES_REST_URL: string = '/rest/languages';

@Injectable({
    providedIn: 'root'
})
export class PrlLanguageService {
    private currentLanguage: string = 'EN';
    private labels: Map<string, string> = new Map<string, string>;
    private languageSubject = new BehaviorSubject<string>(this.currentLanguage);
    public language = this.languageSubject.asObservable();
    private allLanguage: PortalLanguageObj[] = [];

    constructor(
        private httpClient: HttpClient
    ) {
    }

    init(): void {
        this.getPortalLanguages()
            .subscribe( (data) => {
                    if (!Array.isArray(data)) {
                        return;
                    }
                    this.allLanguage = data;
                    const defaultLanguage = data.find(portalLanguage => portalLanguage.default === true);
                    if (defaultLanguage) {
                        this.currentLanguage = defaultLanguage.code;
                    }
                    this.updateLabels(this.currentLanguage);
                }
            );
    }

    public getAllLanguages(): Observable<Array<KeyValueObj>> {
        return this.httpClient.get<Array<KeyValueObj>>(`${LANGUAGES_REST_URL}/all`);
    }

    public getPortalLanguages(): Observable<Array<PortalLanguageObj>> {
        return this.httpClient.get<Array<PortalLanguageObj>>(LANGUAGES_REST_URL);
    }

    public getLabel(label: string): string {
        return this.labels.get(label) !== undefined
            ? this.labels.get(label)
            : label;
    }

    public setLanguage(languageCode: string): void {
        this.currentLanguage = languageCode;
        this.updateLabels(languageCode);
    }

    public getLanguage(): string {
        return this.currentLanguage;
    }

    public getAllLanguageList(): PortalLanguageObj[] {
        return this.allLanguage;
    }

    private updateLabels(languageCode: string): void {
        this.httpClient.get<Array<KeyValueObj>>(`${LANGUAGES_REST_URL}/${languageCode}/labels`)
            .subscribe((data: Array<KeyValueObj>) => {
                data.forEach((keyValueObj) =>
                    this.labels.set(keyValueObj.key, keyValueObj.value));
                this.languageSubject.next(languageCode);
            });
    }
}

